import type { RadioStation } from "@/mocks/radios";

export type LiveStatus = "live" | "scheduled" | "finished";

export interface LiveBroadcast {
  id: number;
  stationId: number;
  station: RadioStation;
  programName: string;
  hostName: string;
  status: LiveStatus;
  scheduledTime: string;
  endTime: string;
  durationMinutes: number;
  description: string;
  coverUrl: string;
}

import { radioStations } from "@/mocks/radios";

export const liveBroadcasts: LiveBroadcast[] = [
  // ── EN VIVO ──
  {
    id: 1,
    stationId: 16,
    station: radioStations.find((s) => s.id === 16)!,
    programName: "Salsa Brava Live",
    hostName: "Carlos 'El Sonero' Vega",
    status: "live",
    scheduledTime: "2026-06-09T18:00:00",
    endTime: "2026-06-09T20:00:00",
    durationMinutes: 120,
    description: "Las mejores mezclas de salsa en vivo con invitados especiales y dedicatorias.",
    coverUrl: "https://readdy.ai/api/search-image?query=Salsa%20music%20live%20radio%20broadcast%20studio%20with%20dj%20headphones%20turntables%20and%20vibrant%20colorful%20lighting%2C%20tropical%20latin%20music%20atmosphere%2C%20professional%20recording%20booth%2C%20warm%20orange%20and%20red%20tones%2C%20dynamic%20energy%2C%20broadcast%20desk%20with%20microphones%2C%20music%20notes%20floating%20in%20the%20air%2C%20stylized%20editorial%20photography%20with%20bokeh%20effect%20and%20dramatic%20stage%20lighting&width=400&height=240&seq=live-salsa-2025&orientation=landscape",
  },
  {
    id: 2,
    stationId: 3,
    station: radioStations.find((s) => s.id === 3)!,
    programName: "Fiesta Mexicana",
    hostName: "Don Fernando Ramírez",
    status: "live",
    scheduledTime: "2026-06-09T17:00:00",
    endTime: "2026-06-09T19:00:00",
    durationMinutes: 120,
    description: "Música regional mexicana, saludos al aire y concursos. El programa más alegre de Houston.",
    coverUrl: "https://readdy.ai/api/search-image?query=Mexican%20regional%20music%20live%20radio%20broadcast%20with%20festive%20studio%20atmosphere%2C%20mariachi%20instruments%2C%20warm%20orange%20and%20red%20ambient%20lighting%2C%20professional%20dj%20console%20with%20traditional%20mexican%20decorations%2C%20vibrant%20colorful%20scene%2C%20broadcast%20microphones%2C%20lively%20party%20energy%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-mexicana-2025&orientation=landscape",
  },
  {
    id: 3,
    stationId: 14,
    station: radioStations.find((s) => s.id === 14)!,
    programName: "Electro Vibes Night",
    hostName: "DJ Spark & MC Luna",
    status: "live",
    scheduledTime: "2026-06-09T20:00:00",
    endTime: "2026-06-09T22:00:00",
    durationMinutes: 120,
    description: "House y techno en vivo con mezclas exclusivas. Los mejores beats desde Miami.",
    coverUrl: "https://readdy.ai/api/search-image?query=Electronic%20dance%20music%20live%20radio%20broadcast%20with%20dj%20mixing%20console%2C%20neon%20cyan%20and%20magenta%20lighting%2C%20futuristic%20studio%20design%2C%20synthesizer%20equipment%2C%20vibrant%20club%20atmosphere%2C%20professional%20broadcast%20setup%20with%20led%20screens%2C%20energetic%20party%20scene%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-electro-2025&orientation=landscape",
  },
  {
    id: 4,
    stationId: 19,
    station: radioStations.find((s) => s.id === 19)!,
    programName: "Hip Hop Central",
    hostName: "Big Mike & DJ Scratch",
    status: "live",
    scheduledTime: "2026-06-09T16:00:00",
    endTime: "2026-06-09T20:00:00",
    durationMinutes: 240,
    description: "Rap, hip hop y cultura urbana desde Atlanta. Batallas de freestyle los viernes.",
    coverUrl: "https://readdy.ai/api/search-image?query=Hip%20hop%20radio%20broadcast%20studio%20with%20turntables%20microphones%20and%20graffiti%20art%2C%20urban%20street%20culture%20vibe%2C%20bold%20gold%20and%20black%20color%20scheme%2C%20professional%20dj%20setup%20with%20vinyl%20records%2C%20atmospheric%20studio%20lighting%2C%20cool%20city%20energy%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-hiphop-2025&orientation=landscape",
  },
  {
    id: 5,
    stationId: 5,
    station: radioStations.find((s) => s.id === 5)!,
    programName: "Rock Total en Vivo",
    hostName: "Alex 'Metal' Torres",
    status: "live",
    scheduledTime: "2026-06-09T15:00:00",
    endTime: "2026-06-09T19:00:00",
    durationMinutes: 240,
    description: "Rock clásico y contemporáneo con entrevistas exclusivas a bandas legendarias.",
    coverUrl: "https://readdy.ai/api/search-image?query=Rock%20music%20live%20radio%20broadcast%20with%20electric%20guitars%20and%20amplifiers%2C%20dark%20studio%20atmosphere%20with%20dramatic%20red%20and%20black%20lighting%2C%20vintage%20vinyl%20records%2C%20professional%20broadcast%20equipment%2C%20concert%20energy%2C%20cool%20rock%20aesthetic%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-rock-2025&orientation=landscape",
  },
  {
    id: 6,
    stationId: 2,
    station: radioStations.find((s) => s.id === 2)!,
    programName: "Amanecer de Esperanza",
    hostName: "Pastora María Elena",
    status: "live",
    scheduledTime: "2026-06-09T06:00:00",
    endTime: "2026-06-09T10:00:00",
    durationMinutes: 240,
    description: "Mensajes de fe, música cristiana y oraciones en vivo para comenzar el día.",
    coverUrl: "https://readdy.ai/api/search-image?query=Christian%20radio%20broadcast%20studio%20with%20warm%20morning%20light%2C%20peaceful%20atmosphere%20with%20dove%20and%20cross%20symbols%2C%20soft%20golden%20and%20white%20color%20palette%2C%20spiritual%20community%20radio%20setup%2C%20professional%20microphones%2C%20serene%20and%20uplifting%20scene%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-fe-2025&orientation=landscape",
  },

  // ── PROGRAMADOS ──
  {
    id: 7,
    stationId: 1,
    station: radioStations.find((s) => s.id === 1)!,
    programName: "Nueva Actitud Nocturna",
    hostName: "Laura Méndez",
    status: "scheduled",
    scheduledTime: "2026-06-09T22:00:00",
    endTime: "2026-06-10T00:00:00",
    durationMinutes: 120,
    description: "El mejor pop y entretenimiento para cerrar el día con buena actitud.",
    coverUrl: "https://readdy.ai/api/search-image?query=Night%20pop%20music%20radio%20broadcast%20studio%20with%20warm%20ambient%20lighting%2C%20sleek%20modern%20design%2C%20headphones%20and%20mixing%20console%2C%20relaxed%20late%20night%20broadcast%20vibe%2C%20soft%20golden%20and%20warm%20tones%2C%20professional%20female%20host%20setup%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-nueva-2025&orientation=landscape",
  },
  {
    id: 8,
    stationId: 13,
    station: radioStations.find((s) => s.id === 13)!,
    programName: "Jazz After Hours",
    hostName: "Robert 'Blue' Johnson",
    status: "scheduled",
    scheduledTime: "2026-06-09T23:00:00",
    endTime: "2026-06-10T01:00:00",
    durationMinutes: 120,
    description: "Jazz clásico y contemporáneo para las horas más tranquilas de la noche.",
    coverUrl: "https://readdy.ai/api/search-image?query=Jazz%20radio%20broadcast%20studio%20late%20night%20session%2C%20saxophone%20and%20piano%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20intimate%20atmosphere%20with%20soft%20candle%20lighting%2C%20vintage%20microphones%2C%20smooth%20sophisticated%20aesthetic%2C%20New%20Orleans%20jazz%20feel%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-jazz-2025&orientation=landscape",
  },
  {
    id: 9,
    stationId: 7,
    station: radioStations.find((s) => s.id === 7)!,
    programName: "Deportes Total Estelar",
    hostName: "Jorge 'El Comentarista' Ruiz",
    status: "scheduled",
    scheduledTime: "2026-06-09T21:00:00",
    endTime: "2026-06-09T23:00:00",
    durationMinutes: 120,
    description: "Análisis deportivo completo. Resultados, entrevistas y polémicas del día.",
    coverUrl: "https://readdy.ai/api/search-image?query=Sports%20talk%20radio%20broadcast%20studio%20with%20sports%20memorabilia%20trophies%20and%20team%20jerseys%2C%20professional%20commentator%20setup%2C%20dynamic%20blue%20and%20gold%20atmosphere%2C%20multiple%20screens%20showing%20game%20highlights%2C%20energetic%20broadcast%20energy%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-deportes-2025&orientation=landscape",
  },
  {
    id: 10,
    stationId: 12,
    station: radioStations.find((s) => s.id === 12)!,
    programName: "Banda en la Noche",
    hostName: "El Compa Chuy",
    status: "scheduled",
    scheduledTime: "2026-06-10T00:00:00",
    endTime: "2026-06-10T02:00:00",
    durationMinutes: 120,
    description: "Pura banda, corridos y música regional para la madrugada texana.",
    coverUrl: "https://readdy.ai/api/search-image?query=Regional%20mexican%20radio%20broadcast%20studio%20with%20traditional%20musical%20instruments%2C%20warm%20festive%20atmosphere%2C%20red%20green%20and%20white%20decorative%20elements%2C%20professional%20dj%20setup%2C%20lively%20texas%20night%20energy%2C%20stylized%20editorial%20photography%20with%20warm%20tones&width=400&height=240&seq=live-banda-2025&orientation=landscape",
  },
  {
    id: 11,
    stationId: 20,
    station: radioStations.find((s) => s.id === 20)!,
    programName: "Country Sunrise",
    hostName: "Billy Ray Thompson",
    status: "scheduled",
    scheduledTime: "2026-06-10T05:00:00",
    endTime: "2026-06-10T08:00:00",
    durationMinutes: 180,
    description: "Country clásico para despertar. Desde Nashville con las mejores canciones.",
    coverUrl: "https://readdy.ai/api/search-image?query=Country%20music%20radio%20broadcast%20studio%20early%20morning%2C%20acoustic%20guitar%2C%20warm%20sunrise%20lighting%20through%20window%2C%20rustic%20wooden%20broadcast%20desk%2C%20cozy%20Nashville%20atmosphere%2C%20cream%20and%20brown%20color%20palette%2C%20professional%20microphone%20setup%2C%20peaceful%20morning%20energy%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-country-2025&orientation=landscape",
  },
  {
    id: 12,
    stationId: 18,
    station: radioStations.find((s) => s.id === 18)!,
    programName: "Reggae Sunset Vibes",
    hostName: "Rasta Mike",
    status: "scheduled",
    scheduledTime: "2026-06-10T18:00:00",
    endTime: "2026-06-10T20:00:00",
    durationMinutes: 120,
    description: "Reggae, dancehall y buenas vibras caribeñas para el atardecer.",
    coverUrl: "https://readdy.ai/api/search-image?query=Reggae%20radio%20broadcast%20studio%20with%20caribbean%20tropical%20vibes%2C%20palm%20trees%20silhouette%2C%20warm%20sunset%20orange%20and%20green%20tones%2C%20relaxed%20island%20atmosphere%2C%20professional%20dj%20setup%20with%20vinyl%20records%2C%20jamaican%20music%20culture%2C%20chill%20peaceful%20energy%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-reggae-2025&orientation=landscape",
  },

  // ── FINALIZADOS ──
  {
    id: 13,
    stationId: 4,
    station: radioStations.find((s) => s.id === 4)!,
    programName: "Noticias 24/7 Primera Edición",
    hostName: "Elena Castellanos",
    status: "finished",
    scheduledTime: "2026-06-09T06:00:00",
    endTime: "2026-06-09T08:00:00",
    durationMinutes: 120,
    description: "Resumen de noticias locales e internacionales. Lo que pasó mientras dormías.",
    coverUrl: "https://readdy.ai/api/search-image?query=News%20radio%20broadcast%20studio%20with%20multiple%20monitors%20showing%20headlines%2C%20professional%20news%20anchor%20setup%2C%20clean%20blue%20and%20white%20aesthetic%2C%20world%20map%20display%20background%2C%20journalistic%20atmosphere%2C%20morning%20edition%20professional%20studio%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-noticias-2025&orientation=landscape",
  },
  {
    id: 14,
    stationId: 11,
    station: radioStations.find((s) => s.id === 11)!,
    programName: "Devocional Matutino",
    hostName: "Hermano José Luis",
    status: "finished",
    scheduledTime: "2026-06-09T05:00:00",
    endTime: "2026-06-09T06:00:00",
    durationMinutes: 60,
    description: "Oración y reflexión para iniciar el día con el pie derecho.",
    coverUrl: "https://readdy.ai/api/search-image?query=Christian%20devotional%20radio%20broadcast%20early%20morning%2C%20peaceful%20sunrise%2C%20cross%20and%20bible%20on%20broadcast%20desk%2C%20soft%20blue%20and%20white%20spiritual%20atmosphere%2C%20serene%20studio%20setup%2C%20warm%20gentle%20lighting%2C%20uplifting%20calm%20energy%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-dev-2025&orientation=landscape",
  },
  {
    id: 15,
    stationId: 10,
    station: radioStations.find((s) => s.id === 10)!,
    programName: "Voz del Pueblo Mañanero",
    hostName: "Comunidad Activa",
    status: "finished",
    scheduledTime: "2026-06-09T07:00:00",
    endTime: "2026-06-09T09:00:00",
    durationMinutes: 120,
    description: "Participación ciudadana, denuncias comunitarias y noticias locales de Denver.",
    coverUrl: "https://readdy.ai/api/search-image?query=Community%20radio%20broadcast%20studio%20with%20local%20neighborhood%20photos%2C%20grassroots%20atmosphere%2C%20warm%20earth%20tones%20and%20green%20colors%2C%20simple%20broadcast%20setup%2C%20inclusive%20community%20feel%2C%20local%20voices%20and%20participation%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-pueblo-2025&orientation=landscape",
  },
  {
    id: 16,
    stationId: 9,
    station: radioStations.find((s) => s.id === 9)!,
    programName: "Kalle Morning Show",
    hostName: "DJ Paula & Bryan",
    status: "finished",
    scheduledTime: "2026-06-09T08:00:00",
    endTime: "2026-06-09T10:00:00",
    durationMinutes: 120,
    description: "El morning show más divertido con noticias de entretenimiento y música pop.",
    coverUrl: "https://readdy.ai/api/search-image?query=Pop%20music%20morning%20radio%20show%20studio%2C%20vibrant%20pink%20and%20purple%20colors%2C%20fun%20energetic%20atmosphere%2C%20two%20hosts%20at%20broadcast%20desk%2C%20modern%20youthful%20aesthetic%2C%20professional%20microphones%20and%20headphones%2C%20exciting%20morning%20show%20vibe%2C%20stylized%20editorial%20photography&width=400&height=240&seq=live-kalle-2025&orientation=landscape",
  },
];

export const liveSample = liveBroadcasts;